import { render, staticRenderFns } from "./GeralMenuComponent.vue?vue&type=template&id=70cc3e1c&scoped=true&"
import script from "./GeralMenuComponent.vue?vue&type=script&lang=js&"
export * from "./GeralMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./GeralMenuComponent.vue?vue&type=style&index=0&id=70cc3e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc3e1c",
  null
  
)

export default component.exports